module.exports = __webpack_public_path__ + "static/media/goBack.5cf651d8.mp3";